The URL of the image, e.g. `https://integration.seek.com/assets/verify-with-seek-pass/button-images/en/standard-neutral.svg`.
